export const contactAddress = (selectedAddress) => {
    let linesWithBreaks = [];

    if (selectedAddress?.name) {linesWithBreaks.push(selectedAddress.name + ',' );}
    if (selectedAddress?.address) {linesWithBreaks.push(selectedAddress.address + ',');}
    
    let stateCountryLine = [];
    if (selectedAddress?.city_name) {stateCountryLine.push(selectedAddress.city_name + ',');}
    if (selectedAddress?.state_name) {stateCountryLine.push(selectedAddress.state_name + ', '); }

    if (stateCountryLine.length > 0) {
        linesWithBreaks.push(stateCountryLine.join(' '));
    }

    if (selectedAddress?.country_name) {linesWithBreaks.push(selectedAddress.country_name + ', ');}
    if (selectedAddress?.zipCode) {linesWithBreaks.push(selectedAddress.zipCode);}
    
    
    if (linesWithBreaks.length === 0) {
        linesWithBreaks.push(selectedAddress.value + ',' );
    }
    return linesWithBreaks;
} 

export const concatCompany = (company) => {

    let linesWithBreaks = [];

    if (company?.Title) {linesWithBreaks.push(company.Title + ',' );}
    if (company?.BillAddress) {linesWithBreaks.push(company.BillAddress + ',');}

    const cityName = company?.cityName || company?.city_name;
    if (cityName) {linesWithBreaks.push(cityName + ',');}

    let stateCountryLine = [];
    const stateName = company?.stateName || company?.state_name;
    if (stateName) {stateCountryLine.push(stateName + ', '); }

    const countryName = company?.countryName || company?.country_name;
    if (countryName) {stateCountryLine.push(countryName + ', ');}
    if (company?.PostalZipCode) {stateCountryLine.push(company.PostalZipCode);}
    
    if (stateCountryLine.length > 0) {
        linesWithBreaks.push(stateCountryLine.join(' '));
    }

    return linesWithBreaks;
}

export const findObject = (data, cache) => { // objeto y dato a buscar
    return data.find(objeto => objeto.id === cache);
}

export const listChek = () => {
    const obj = [
        { id: 'label_approved',  value: "Fruitrade's Label Approved" },
        { id: 'specification_sent', value: 'Specifications Sent' },
        { id: 'customer_po', value: 'Customer PO' },
        { id: 'compliance', value: 'Compliance Package' },
        { id: 'purcharse_confirmation_sent', value: 'Purchase confirmation sent'},
        { id: 'sales_confirmation_sent', value: 'Sales confirmation sent'},
        { id: 'quantity_required', value: 'Quality Inspection Required?'},
    ];
    return obj;
}

export const validateForm = (inputs, validations, toast) => {
    for (const [field, message] of Object.entries(validations)) {  
        const value = field.split('.').reduce((o ,i) => o[i], inputs);
        if (!value) {
            toast.e(message);
            return false;
        }
        if (typeof value === 'object') {
            if (!Object.values(value)[0]) {
                toast.e(message);
                return false;
            }   
        }
    }
    return true;
}
